/* In-page jump (schools landing preview, 2026-09-30): scroll a target into
   view, smooth unless the visitor asked for reduced motion, and put its id
   in the address bar so the spot can be shared. The target's own
   scroll-margin-top (88 px on the landing pages) keeps it clear of the
   64 px fixed nav. Focus moves to the target (without a second scroll) so
   keyboard and screen-reader users land where the page moved.
   Returns false when the id is not on the page, so a caller can let the
   browser follow the link instead.
   options.instant (schools preview, 2026-09-30): no smooth scroll, for a
   #hash on a fresh page load. Without options it behaves as before. */
export default function jumpTo(id, options = {}) {
  if (typeof document === 'undefined') return false;
  const el = document.getElementById(id);
  if (!el) return false;
  const reduce = Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  // 'instant', not 'auto': 'auto' inherits a page's CSS smooth scrolling,
  // which turned a fresh-load jump into a 1.5 s glide (critique2 #13)
  el.scrollIntoView({ behavior: options.instant ? 'instant' : (reduce ? 'auto' : 'smooth'), block: 'start' });
  try {
    window.history.replaceState(window.history.state, '', `#${id}`);
  } catch (e) {
    /* a sandboxed frame may refuse; the scroll already happened */
  }
  if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
  try {
    el.focus({ preventScroll: true });
  } catch (e) {
    /* old engines without focus options */
  }
  return true;
}

/* onClick for an <a href="#id"> or a router <Link>: jump in place and stop
   the default navigation; if the target is missing, let the link work. */
export const jumpClick = (id, after) => (e) => {
  if (e && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0)) return;
  if (jumpTo(id) && e) e.preventDefault();
  if (after) after();
};
